import React from 'react';

const WorkOrderDetailsModal = ({ isOpen, onClose, workOrders = [] }) => {
    if (!isOpen) return null;

    // Check if workOrders is a valid array and has content
    const hasWorkOrders = Array.isArray(workOrders) && workOrders.length > 0;

    return (
        <div className="modal-background1">
            <div className="modal1">
                <h3 className="mt-3">Work Order Details</h3>
                <table className="tabled">
                    <thead>
                        <tr>
                            <th>WO Number</th>
                            <th>Completion Date</th>
                            <th>Site</th>
                            <th>Status</th>
                            <th>Template</th>
                        </tr>
                    </thead>
                    <tbody>
                        {hasWorkOrders ? (
                            workOrders.map((wo, index) => (
                                <tr key={index}>
                                    <td>{wo.wo_num}</td>
                                    <td>{wo.wo_comp_date ? wo.wo_comp_date.split('T')[0] : ''}</td>
                                    <td>{wo.site_id}</td>
                                    <td>{wo.final_status}</td>
                                    <td>{wo.template}</td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="5">No work orders available</td>
                            </tr>
                        )}
                    </tbody>
                </table>
                <button onClick={onClose}>Close</button>
            </div>
        </div>
    );
};

export default WorkOrderDetailsModal;
